import React, { useState } from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import { Menu, MenuItem } from '@mui/material';

import { getActiveComponentDesign } from '../../../store/selectors/getActiveComponentDesignSelector';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { useSettingsOperations } from '../../misc/menus/shared-menu-items/SettingsSubMenu';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function TrussSettingsButton() {
  const dispatch = useAppDispatch();

  const inLayoutMode = useAppSelector(isLayoutViewActive);

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const componentDesign = useAppSelector(getActiveComponentDesign);
  const operations = useSettingsOperations(componentDesign ? { type: 'componentDesign', item: componentDesign } : null);

  const disabled = componentDesign == null || operations.length === 0;

  if (inLayoutMode) return null;

  return (
    <>
      <ToolbarIconButton
        icon={<SettingsIcon />}
        title="Truss Settings"
        disabled={disabled}
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      />

      {anchorEl != null && !disabled && (
        <Menu open anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
          {operations.map((operation) => (
            <MenuItem
              key={operation.key}
              disabled={operation.disabled}
              onClick={() => {
                setAnchorEl(null);
                dispatch(operation.getActionToDispatch());
              }}
            >
              {operation.text}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
}
